import register from '../../../../global/js/registry';
export default register('o-fab-menu', () => import(/* webpackMode: "lazy" */ './o-fab-menu.controller'));
